/**
 * E.g. '2023-03-06'
 */
export const dateFormatRegex = /^\d{4}-\d{1,2}-\d{1,2}$/;
